import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Button,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

export const Wraper = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('lg')]: {
    maxWidth: '600px',
    marginBottom: 8,
  },
  '& .k-chart, .k-stockchart': {
    height: '100% !important',
  },
}));

export const SelectionStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  backgroundColor: theme.palette.colors.primaryBackground,
  justifyContent: 'space-evenly',
}));

export const ButtonStyled = styled('div')(({ theme }) => ({
  flexWrap: 'initial',
  height: 32,
  width: 296,
  margin: '0 16px',
  backgroundColor: theme.palette.colors.primaryBackground,
  border: 'solid 1px',
  borderColor: theme.palette.colors.lower,
  color: theme.palette.colors.onPrimaryBackground,
  display: 'flex',
  justifyContent: 'center',
  fontSize: 12,
  alignItems: 'center',
  fontWeight: 'bold',
  borderRadius: 5,
}));

export const Tables = styled(TableContainer, {
  shouldForwardProp: (prop) => prop !== 'height',
})(({ theme, height }) => ({
  display: 'flex',
  backgroundColor: theme.palette.colors.selectedAndDetailBackground,
  overflowY: 'auto',
  height,

  '@-moz-document url-prefix()': {
    scrollbarColor: `${theme.palette.colors.scrollOnPrimaryBackground} transparent`,
    scrollbarWidth: 'thin',
  },
  '&::-webkit-scrollbar': {
    width: '6px',
  },
  '&::-webkit-scrollbar-track': {
    boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
    webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.colors.scrollOnPrimaryBackground,
    borderRadius: '5px',
  },
}));

export const TableStyled = styled(Table)(({ theme }) => ({
  color: theme.palette.colors.onPrimaryBackground,
}));

export const TableHeadStyled = styled(TableHead)(({ theme }) => ({
  textAlign: 'center',
  '& tr': {
    border: 0,
    margin: 0,
    borderRadius: 'unset',
  },
  '& th': {
    color: theme.palette.colors.mainFocused,
    fontWeight: '600',
    textTransform: 'lowercase',
  },
}));

export const TableRowStyled = styled(TableRow)(({ theme }) => ({
  minHeight: 32,
  margin: '4px 0 4px 0px',
  borderRadius: 5,
  backgroundColor: theme.palette.colors.primaryBackground,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-around',
  '& td.left': {
    textAlign: 'left',
  },

  [theme.breakpoints.down('lg')]: {
    justifyContent: 'space-between',

    '& td.detailProperty': {
      textAlign: 'right',
    },
  },
}));

export const TableCellStyled = styled(TableCell, {
  shouldForwardProp: (prop) => prop !== 'uppercased',
})(({ theme, uppercased }) => ({
  maxHeight: 32,
  minWidth: '33%',
  textAlign: 'center',
  fontSize: 12,
  padding: '10px 0 8px 0',
  border: 0,
  fontWeight: '500',
  color: theme.palette.colors.onPrimaryBackground,
  textTransform: uppercased && 'uppercase !important',
  '&.green_title': {
    color: theme.palette.colors.mainFocused,
    fontWeight: 'bold',
  },

  [theme.breakpoints.down('lg')]: {
    width: '45%',
    minWidth: 'auto',
    padding: '10px 16px 8px',
  },
}));

export const TableBodyStyled = styled(TableBody, {
  shouldForwardProp: (prop) => prop !== 'maxHeight',
})(({ theme, maxHeight }) => ({
  color: theme.palette.colors.onPrimaryBackground,
  maxHeight,
  overflowY: 'auto',

  '&.rightCollum tr': {
    marginLeft: 4,
  },
}));

export const ButtonLink = styled(Button)(({ theme }) => ({
  color: theme.palette.colors.onPrimaryBackground,
  fontSize: 12,
  fontWeight: 500,
  textTransform: 'capitalize',
  padding: 0,
  '&:hover': {
    textDecoration: 'underline',
  },
}));

export const FileIconStyled = styled(FontAwesomeIcon)(({ theme }) => ({
  fontSize: '16px',
  color: theme.palette.colors.mainFocused,
  marginRight: '8px',
}));
